import { render, staticRenderFns } from "./realProjectCom.vue?vue&type=template&id=4e2ffd87&scoped=true"
import script from "./realProjectCom.vue?vue&type=script&lang=js"
export * from "./realProjectCom.vue?vue&type=script&lang=js"
import style0 from "./realProjectCom.vue?vue&type=style&index=0&id=4e2ffd87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2ffd87",
  null
  
)

export default component.exports